import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import routes from './router/index'
import '../src/assets/css/ecommerce.css';
import '../src/assets/css/guest.css';
import '../src/assets/css/index.css';
import '../src/assets/css/style.css';
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)
Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App),router:routes
}).$mount('#app')